import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InicioFaces} from '../interfaces/inicioFaces';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";

@Injectable({
  providedIn: 'root'
})
export class CartasService {
	public httpOptions = {
		headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*'
		})

	};

API_ENDPOINT: string = Constants.BASEURLAPI  + '/api';

  constructor(private httpClient: HttpClient) { }

static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
	let config = {
		'required': 'Este campo es requerido'
	};
	return config[validatorName];
}

public consultaCedula(consulta : any) {
const  params = new  HttpParams().set('cedula', consulta.cedula).set('fexpide', consulta.fexpide).set('login_id', consulta.login_id);
return this.httpClient.get(this.API_ENDPOINT + '/consultaCedula',{params});
} 



}
